/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Graduationfirsttesttopic3Inputs */

const de__field_graduationfirsttesttopic3 = /** @type {(inputs: _Field_Graduationfirsttesttopic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstes Prüfungsthema Abschluss`)
};

/**

* @param {_Field_Graduationfirsttesttopic3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_graduationfirsttesttopic3 = /** @type {((inputs?: _Field_Graduationfirsttesttopic3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Graduationfirsttesttopic3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_graduationfirsttesttopic3(inputs)
});
export { _field_graduationfirsttesttopic3 as "_field_graduationFirstTestTopic" }